import React, {Component} from "react";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import EmptyStatus from "../../components/EmptyStatus";
import ActionButton from "../../components/ActionButton";
import ProductTable from "./ProductTable";
import {fromJS} from "immutable";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {LIST_CART_FOR_ACCOUNT, ON_CART_UPDATED} from "../../queries/sales";
import {requestEditProductInCart, requestEditSubscriptionInCart, beginCheckout} from "../../actions/AccountApiActions";
import "./CartList.css";

class CartList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToCartUpdates(this.props, {}); 
  }

  render() {
    let {loading, error, cart} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let items = fromJS(cart.items)
    if (items.size === 0) {
      return <EmptyStatus status="No items found in cart" />
    }
    return (
      <div className="CartListWrapper">
        <ProductTable
          onItemClick={this.handleItemClick.bind(this)} 
          products={items}
          subscriptionName={cart.subscriptionName}
          subscriptionFrequencyWeeks={cart.subscriptionFrequencyWeeks}
          />

        <div className="total">Subtotal: {cart.subtotal} {cart.currency}</div>
        <ActionButton label="Checkout" onClick={this.handleCheckout.bind(this)} />
      </div>
    )
  }

  handleItemClick(itemData) {
    let id = itemData.get("productSku");
    if (itemData.get("subscription") === true) {
      this.props.requestEditSubscriptionInCart(this.props.accountId);
    } else {
      this.props.requestEditProductInCart(this.props.accountId, id);
    }
  }  

  handleCheckout() {
    let values = { accountId: this.props.accountId }
    return this.props.checkoutCart(values)
      .then((response) => {
        if (response.data.checkoutCart.errors.length <= 0) {
          // Do nothing, or signal going to other page.
          this.props.beginCheckout(this.props.accountId, response.data.checkoutCart.orderId);
        } else {
          console.warn("An error occured", response.data.checkoutCart.errors);
        }
      })
      .catch((err) => {
        console.warn("An exception occured", err);
      });          
  }

}

const CHECKOUT_CART = gql`
  mutation checkoutCart($data: AccountInput!) {
    checkoutCart(input: $data) {
      orderId
      errors { key message }
    }
  }
`;

const mapDispatchToProps = dispatch => ({
  subscribeToCartUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_CART_UPDATED,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = compose(
  graphql(LIST_CART_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }    
    })
  }),
  graphql(CHECKOUT_CART, {
    props: ({ mutate }) => ({
      checkoutCart: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {requestEditProductInCart, requestEditSubscriptionInCart, beginCheckout})(withQuery(withSubscription(CartList)));